import styled from 'styled-components';

import { LUMIO_MORPH, REDUCED_MOTION } from '../../../../../theme/tokens';

/** The morph slot (the logo footprint, so the host layout is stable): 24px in the deploy header by default.
 *  `overflow: visible` lets the larger strands flourish bloom past the slot. */
export const Root = styled.span<{ $size: number }>`
  position: relative;
  display: block;
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
  flex-shrink: 0;
  overflow: visible;
`;

/** The Lumio mark — fills the 24px slot; fades + scales out when strands take over. */
export const LogoLayer = styled.span<{ $show: boolean }>`
  position: absolute;
  inset: 0;
  display: block;
  opacity: ${(p) => (p.$show ? 1 : 0)};
  transform: scale(${(p) => (p.$show ? 1 : 0.82)});
  transition:
    opacity ${LUMIO_MORPH.fadeMs}ms ease,
    transform ${LUMIO_MORPH.fadeMs}ms ease;

  img {
    display: block;
    width: 100%;
    height: 100%;
  }

  ${REDUCED_MOTION} {
    transition: none;
  }
`;

/** The strands flourish — a larger canvas centred on the logo slot (overflows it),
 *  so the animation reads big rather than minuscule. */
export const StrandsLayer = styled.span<{ $show: boolean; $size: number }>`
  position: absolute;
  top: 50%;
  left: 50%;
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
  opacity: ${(p) => (p.$show ? 1 : 0)};
  transform: translate(-50%, -50%) scale(${(p) => (p.$show ? 1 : 0.82)});
  transition:
    opacity ${LUMIO_MORPH.fadeMs}ms ease,
    transform ${LUMIO_MORPH.fadeMs}ms ease;
  pointer-events: none;

  ${REDUCED_MOTION} {
    transition: none;
  }
`;
